<template>
  <div>
    <GameAreaScreen v-if="activeGamePlayScreen == 'GAME_AREA_SCREEN'" />
    <CardRequestedScreen v-else-if="activeGamePlayScreen == 'CARD_REQUESTED_SCREEN'" />
    <FinalisingTradeScreen v-else-if="activeGamePlayScreen == 'FINALISING_TRADE_CARD_SCREEN'" />
    <GamePausePhase v-if="isPaused" />
  </div>
</template>

<script setup lang="ts">
import GameAreaScreen from '@/components/screens/game-play/GameAreaScreen.vue'
import CardRequestedScreen from '@/components/screens/game-play/CardRequestedScreen.vue'
import FinalisingTradeScreen from '@/components/screens/game-play/FinalisingTradeScreen.vue'
import GamePausePhase from '@/components/phases/GamePausePhase.vue'
import { useAppStore } from '@/stores/app'

import { useGameStore } from '@/stores/game'
import { storeToRefs } from 'pinia'

const { isPaused } = storeToRefs(useAppStore())

const { activeGamePlayScreen } = storeToRefs(useGameStore())
</script>

<style scoped></style>
